'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { TDynamicData } from '../../types/dynamic-data';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

import { Autoplay, Pagination } from 'swiper/modules';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Heading } from '../shared/heading';

export const HeroSwiper = ({ slides }: { slides: TDynamicData[] }) => {
  return (
    <Swiper
      autoplay={{
        delay: 5000,
        disableOnInteraction: false,
      }}
      loop={true}
      pagination={true}
      modules={[Pagination, Autoplay]}
      className={cn('mySwiper', 'ea-hero-swiper', 'h-full w-full px-6')}
    >
      {slides.map((slide: any) => (
        <SwiperSlide
          key={slide.name}
          className="relative flex !h-[550px] w-full items-center justify-center px-6 pb-[170px] pt-[230px] md:h-fit md:pb-[200px] lg:pb-[320px] lg:pt-[400px]"
        >
          <Heading
            props={{
              title: slide.name ?? 'Právnici s ľudskou tvárou',
              className: {
                container:
                  'py-3 sm:py-5 px-3 sm:px-4 lg:px-10 bg-[#D9D9D9] relative z-[5] w-fit mx-auto text-center',
                title: 'uppercase text-center',
              },
            }}
          />
          <Image
            src={slide.image.url ?? '/images/placeholder.png'}
            alt={resolveImageAlt(slide?.image, slide?.name)}
            sizes="100vw"
            fill
            className="absolute inset-0 z-[0] h-full w-full object-cover object-center"
            priority
            loading="eager"
          />
        </SwiperSlide>
      ))}
    </Swiper>
  );
};
